<div class="container p-2">
  <div class="mat-dialog-content" >
    <p>Are you sure you want to cancel quote trip</p>
  </div>

  <div class="flex_container" mat-dialog-actions>
    <button
      class="ex1"
      mat-buttonn
      mat-dialog-close
      (click)="cancelQuote(data)"
    >
      Yes
    </button>
    <button class="ext" mat-button mat-dialog-close>
      No
    </button>
  </div>
</div>